import React from 'react'
import TodoPage from './page/todo'

function App() {
  return (
    <div>
      <TodoPage />
    </div>
  )
}

export default App
